import React from 'react'
import classNames from 'classnames'
import { SortableContainer, SortableElement } from 'react-sortable-hoc'

import thumbnails from './template/thumbnails'

import './NavigationSidebar.scss'

const moveInArray = (arr, fromIndex, toIndex) => {
  const copyArr = [...arr]
  const element = copyArr[fromIndex]
  copyArr.splice(fromIndex, 1)
  copyArr.splice(toIndex, 0, element)
  return copyArr
}

const Slide = ({ i, activeSlideIndex, onChangeSlide, slide }) => (
  <button
    className={classNames('navigation-sidebar__slide', {
      'navigation-sidebar__slide--active': i === activeSlideIndex,
    })}
    onClick={() => onChangeSlide(i)}
    title={slide.data.title}
  >
    <span className="navigation-sidebar__title">
      {i + 1}: {slide.data.title}
    </span>
    <img
      className="navigation-sidebar__thumbnail"
      src={thumbnails[slide.template] ?? thumbnails.defaultImage}
      alt={slide.template}
    />
    <div className="navigation-sidebar__hover-wrapper" key={`${i}img`}>
      <img src="../../static/img/icons-8-drag.png" />
    </div>
  </button>
)

const SortableItem = SortableElement((props) => <Slide {...props} />)

const Slides = ({ activeSlideIndex, slides, onChangeSlide }) => (
  <For each="slide" index="i" of={slides}>
    <SortableItem
      // SORTABLE PROPS:
      index={i}
      // CUSTOM PROPS:
      key={i}
      i={i}
      activeSlideIndex={activeSlideIndex}
      slide={slide}
      onChangeSlide={onChangeSlide}
    />
  </For>
)

const SortableList = SortableContainer((props) => {
  return (
    <div className="navigation-sidebar__slides">
      <Slides {...props} />
    </div>
  )
})

// component
const NavigationSidebar = ({ slides, activeSlideIndex, onChangeSlide, onChangeSlideOrder }) => {
  const handleSortEnd = ({ oldIndex, newIndex }) => {
    const newList = moveInArray(slides, oldIndex, newIndex)
    onChangeSlideOrder(newList)
  }

  return (
    <div className="navigation-sidebar">
      <SortableList
        // SORTABLE PROPS:
        onSortEnd={handleSortEnd}
        axis="y"
        lockAxis="y"
        helperClass="navigation-sidebar__slide--dragging"
        distance={5}
        // CUSTOM PROPS:
        activeSlideIndex={activeSlideIndex}
        slides={slides}
        onChangeSlide={onChangeSlide}
      />
    </div>
  )
}

// export
export default NavigationSidebar
